import { useMediaQuery } from "@material-ui/core";

export const useDialogModes = () => {
    const fullscreen = useMediaQuery("(max-width:600px)");
    return { fullscreen };
};
